import Routers from './routers';
import { ErrorBoundary } from 'react-error-boundary';
import { NoRecord } from 'components/generic';

function App() {
  return (
    <>
      <ErrorBoundary FallbackComponent={NoRecord}>
          <Routers />
      </ErrorBoundary>
    </>
  )
}

export default App

